<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24">
    <path
      d="M8.59 16.58L13.17 12L8.59 7.41L10 6l6 6l-6 6l-1.41-1.42z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "MdiChevronRight",
};
</script>
